import classNames from 'classnames'
import React from "react"
import { Modal, ModalHeader, ModalFooter, Button, ModalBody, Input } from "reactstrap"
import { useInputValue } from "web/hooks/useInputValue"
import { useKeyShortcut } from 'web/hooks/useKeyShortcut'
import { assertDefined } from 'web/utils/utils'
import { ModalContainerProps } from './_ModalContainer'

export type TextAreaModalProps = {
    title: string
    text: string
    onConfirm?: (text: string) => void
    cancelText?: string
    style?: {
        size?: "md" | "lg"
        readonly?: boolean
        monospace?: boolean
    }
}

export const TextAreaModal: React.FC<TextAreaModalProps & ModalContainerProps> = (props) => {

    const [value, setValue] = useInputValue(props.text)
    const { closeSelf } = props

    const style = props.style ?? {
        size: "md",
        monospace: false,
        readonly: false
    }

    const handleSave = () => {
        props.closeSelf()

        assertDefined(props.onConfirm)
        props.onConfirm(value)
    }

    useKeyShortcut({
        key: "s",
        modifier: "ctrl",
        callback: handleSave,
        disabled: props.onConfirm == null
    })

    const cancelText = props.cancelText ?? "Cancel"

    return (
        <Modal
            isOpen
            fade={false}
            size={style.size}
            centered
            backdrop={"static"}
            toggle={props.closeSelf}
        >
            <ModalHeader>
                {props.title}
            </ModalHeader>

            <ModalBody className="p-3 m-0 bg-light">
                <Input
                    type="textarea"
                    bsSize='sm'
                    style={{ minHeight: "250px" }}
                    value={value}
                    onChange={setValue}
                    readOnly={style.readonly}
                    className={classNames(
                        { "text-monospace": style.monospace }
                    )}
                />
            </ModalBody>

            <ModalFooter className="d-flex justify-content-end space-mx-2" >
                {props.onConfirm != null &&
                    <Button
                        color="success"
                        size="sm"
                        onClick={handleSave}
                        title={"Confirm (ctrl+s)"}
                    >
                        {"Confirm"}
                    </Button>
                }

                <Button
                    outline
                    size="sm"
                    onClick={closeSelf}
                    title={`${cancelText} (esc)`}
                >
                    {cancelText}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
